/* istanbul ignore file */
interface ErrorProps extends React.HTMLAttributes<HTMLParagraphElement> {
  error: string;
}

const Error: React.FC<ErrorProps> = ({ error, ...rest }: ErrorProps) => (
  <p data-testid="error-message" className="mt-2 text-sm text-red-600 text-left" {...rest}>
    {error}
  </p>
);

export default Error;
